import ROUTES from 'libs/constants/routes';
import { CHANNEL } from 'domains/landing-autos/enums/channel';

export const isAutoEfectivoLanding = window.location.pathname.includes(
  ROUTES.LANDING_AE,
);

export const isAutoEfectivoBCP = /(^|\/)bcpautoefectivo(\/|$)/.test(
  window.location.pathname,
);

const matchPathSegment = (segment: string, subPath: string = ''): boolean => {
  const subPathPart = subPath ? `\\/${subPath}` : '';
  const regex = new RegExp(`(^|\\/)${segment}${subPathPart}(\\/|$)`);
  return regex.test(window.location.pathname);
};

export const isAutoEfectivoYape = matchPathSegment(CHANNEL.YAPE_AUTOEFECTIVO);

export const isAutoEfectivoYapeMain = matchPathSegment(
  CHANNEL.YAPE_AUTOEFECTIVO,
  'principal',
);

export const isBcpBexExperience = (channel: string | null) =>
  Boolean(channel && channel.includes('bcpbex-experiencia'));

export const isBCPAdvisorLanding = (channel: string | null) =>
  Boolean(channel && channel.includes('bcpcallcenter'));

export const isAdvisorPilotLanding = (channel: string | null) =>
  Boolean(channel && /(^|\/)callcenter(\/|$)/.test(channel));

export const isPilotChannelLanding = (channel: string | null) =>
  isBcpBexExperience(channel) ||
  isAdvisorPilotLanding(channel) ||
  isBCPAdvisorLanding(channel);

export const getChannel = (channel: string | null) =>
  isBcpBexExperience(channel) && channel ? channel.split('-')[0] : channel;

export const getChannelName = () =>
  window.location.pathname.split('/').at(2) || '';
